/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './root';
import { Route as uiRouterRouteImport } from './ui-router';
import { Route as terminalTerminalListRouteImport } from './terminal/terminal-list';

const uiRouterRoute = uiRouterRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any);
const terminalTerminalListRoute = terminalTerminalListRouteImport.update({
  id: '/terminal/list',
  path: '/terminal/list',
  getParentRoute: () => rootRouteImport,
} as any);

export interface FileRoutesByFullPath {
  '/$': typeof uiRouterRoute;
  '/terminal/list': typeof terminalTerminalListRoute;
}
export interface FileRoutesByTo {
  '/$': typeof uiRouterRoute;
  '/terminal/list': typeof terminalTerminalListRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/$': typeof uiRouterRoute;
  '/terminal/list': typeof terminalTerminalListRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths: '/$' | '/terminal/list';
  fileRoutesByTo: FileRoutesByTo;
  to: '/$' | '/terminal/list';
  id: '__root__' | '/$' | '/terminal/list';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  uiRouterRoute: typeof uiRouterRoute;
  terminalTerminalListRoute: typeof terminalTerminalListRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$': {
      id: '/$';
      path: '/$';
      fullPath: '/$';
      preLoaderRoute: typeof uiRouterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/terminal/list': {
      id: '/terminal/list';
      path: '/terminal/list';
      fullPath: '/terminal/list';
      preLoaderRoute: typeof terminalTerminalListRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  uiRouterRoute: uiRouterRoute,
  terminalTerminalListRoute: terminalTerminalListRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
